package com.trevorwiebe.timesheet.mileage.data

import com.trevorwiebe.timesheet.core.data.FirestoreListenerRegistry
import com.trevorwiebe.timesheet.core.data.Utils.errorWrapper
import com.trevorwiebe.timesheet.core.domain.CoreRepository
import com.trevorwiebe.timesheet.core.domain.TSResult
import com.trevorwiebe.timesheet.mileage.data.dto.EquipmentDto
import com.trevorwiebe.timesheet.mileage.data.dto.toEquipment
import com.trevorwiebe.timesheet.mileage.data.dto.toEquipmentDto
import com.trevorwiebe.timesheet.mileage.domain.EquipmentRepository
import com.trevorwiebe.timesheet.mileage.domain.model.Equipment
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map

class EquipmentRepositoryImpl(
    private val firebaseDatabase: Firebase,
    private val coreRepository: CoreRepository
) : EquipmentRepository {

    override suspend fun getEquipment(): Flow<TSResult> {
        val orgIdResult = coreRepository.getOrganizationId()
        if (orgIdResult.error != null) return kotlinx.coroutines.flow.flow { emit(orgIdResult) }
        val orgId = orgIdResult.data as String

        val flow = firebaseDatabase.firestore
            .collection("organizations")
            .document(orgId)
            .collection("equipment")
            .snapshots
            .map { snapshot ->
                snapshot.documents.map { doc -> doc.data<EquipmentDto>().toEquipment(id = doc.id) }
            }
            .map { TSResult(data = it) }

        return FirestoreListenerRegistry.registerFlow(flow)
    }

    override suspend fun addEquipment(equipment: Equipment): TSResult {
        return errorWrapper {
            val orgId = coreRepository.getOrganizationId().data as String
            firebaseDatabase.firestore
                .collection("organizations")
                .document(orgId)
                .collection("equipment")
                .add(equipment.toEquipmentDto())
            TSResult(data = "Equipment added successfully")
        }
    }

    override suspend fun updateEquipment(equipment: Equipment): TSResult {
        return errorWrapper {
            val orgId = coreRepository.getOrganizationId().data as String
            firebaseDatabase.firestore
                .collection("organizations")
                .document(orgId)
                .collection("equipment")
                .document(equipment.id)
                .set(equipment.toEquipmentDto(), merge = true)
            TSResult(data = "Equipment updated successfully")
        }
    }
}
